import AccesibiltyButton from '@/components/atoms/accesibiltyButton/accesibiltyButton';
import Loader from '@/components/atoms/loader/loader';
import ChatButton from '@/components/molecules/chat-button/chatButton';
import Footer from '@/components/molecules/footer/footer';
import Header from '@/components/molecules/header/header';
import Menu from '@/components/molecules/menu/menu';
import {
    CDC_APIKEY,
    CDC_APIKEY_IDP,
    GIGYA_API_KEY,
} from '@/constants/api-constants';
import GlobalContext from '@/contexts/globalContext';
import { TabsEnum } from '@/enums/enums';
import { GetUnlogedToken } from '@/services/refreshToken';
import useBrowserMode from '@/shared/hooks/useBrowserMode';
import useChangeTheme from '@/shared/hooks/useChangeTheme';
import useDirectionScroll from '@/shared/hooks/useDirectionScroll';
import useLoginGigya from '@/shared/hooks/useLoginGigya';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { graphql, Script, useStaticQuery } from 'gatsby';
import { useEffect, useMemo, useState } from 'react';
import Cookies from 'universal-cookie';
import LoginRequest from '../login-request/login-request';
import Onbording from '../onbording/onbording';
import './layout.scss';

const Layout = ({
    children,
    sideMenu,
    isMain,
    isPrivate = false,
    hideSide,
    hasLoader = false,
    serviceId,
}: any) => {
    const [superFooter, setSuperFooter] = useState<boolean>(false);
    const { isBrowser, localStorage, document, window } = useBrowserMode();
    const { resetDirection } = useDirectionScroll();
    const [size, setSize] = useState(0);
    const gigyaContext = useLoginGigya();
    const [isDark, changeDarkMode] = useChangeTheme();
    const [selectedTab, setSelectedTab] = useState<any>(TabsEnum.PEOPLE);
    const [selectedService, setSelectedService] = useState();
    const [isSearcherActive, setIsSearcherActive] = useState(false);
    const [business, setBusiness] = useState<any>();
    const [userVerificationData, setUserVerificationData] = useState();
    const [isHome, setIsHome] = useState(true);
    const [checkUser, setCheckUser] = useState(false);
    const [checkPermissionPage, setCheckPermissionPage] = useState();
    const [loader, setLoader] = useState(true);
    const [token, setToken] = useState({});
    const [isSessionNeeded, setIsSessionNeeded] = useState(false);

    const data = useStaticQuery(graphql`
        query CHAT_BUTTON {
            allContentfulPortalServiciosChat {
                nodes {
                    botonesInternos {
                        nombre
                        icono
                        imagen {
                            title
                            file {
                                url
                            }
                            gatsbyImageData(
                                formats: [AUTO, WEBP]
                                placeholder: BLURRED
                            )
                        }
                        redireccion
                    }
                    icono {
                        title
                        file {
                            url
                        }
                        gatsbyImageData(
                            formats: [AUTO, WEBP]
                            placeholder: BLURRED
                        )
                    }
                    iconoCerrar {
                        title
                        file {
                            url
                        }
                        gatsbyImageData(
                            formats: [AUTO, WEBP]
                            placeholder: BLURRED
                        )
                    }
                }
            }
        }
    `);
    const cookies = new Cookies();

    useEffect(() => {
        setTimeout(() => {
            setCheckUser(true);
        }, 2000);
    }, []);

    useEffect(() => {
        if (checkUser) {
            if (!gigyaContext.gigyaAccount) {
                cookies.remove('CURRENT_BUSINESS');
            } else {
                if (cookies.get('CURRENT_BUSINESS')) {
                    const dat = cookies.get('CURRENT_BUSINESS').toString();
                    const decryptionObj = CryptoJS.AES.decrypt(dat, 'comfama');
                    const decryptedData = JSON.parse(
                        decryptionObj.toString(CryptoJS.enc.Utf8)
                    );
                    setBusiness(decryptedData);
                }
            }
        }
    }, [checkUser]);

    useEffect(() => {
        const tab = localStorage.getItem('CURRENT_TAB')
            ? localStorage.getItem('CURRENT_TAB')
            : null;
        const paths =
            window?.location?.pathname?.charAt(
                window?.location?.pathname?.length - 1
            ) === '/'
                ? window?.location?.pathname?.slice(0, -1).split('/')
                : window?.location?.pathname?.split('/');
        if (paths?.includes('empresas')) {
            localStorage.setItem('CURRENT_TAB', TabsEnum.BUSINESS);
            setSelectedTab(TabsEnum.BUSINESS);
        } else if (paths?.includes('personas')) {
            localStorage.setItem('CURRENT_TAB', TabsEnum.PEOPLE);
            setSelectedTab(TabsEnum.PEOPLE);
        } else {
            setSelectedTab(tab || TabsEnum.PEOPLE);
        }
    }, []);

    useEffect(() => {
        if (isBrowser) {
            const realSize = parseInt(
                localStorage.getItem('font-size') || '100'
            );
            const item = document.querySelector('html') || {
                style: { fontSize: realSize },
            };
            item.style.fontSize = `${realSize}%`;
            setSize(realSize);
            toLocalStoragepageActive();
        }
        isBrowser && document.addEventListener('scroll', onScrollAction);
        return () => {
            isBrowser && document.removeEventListener('scroll', onScrollAction);
        };
    }, []);

    const getToken = async () => {
        try {
            if (gigyaContext.gigyaAccount !== undefined) {
                const config: any = {
                    headers: {
                        apikey: CDC_APIKEY,
                    },
                };

                const data = {
                    action: 'getJWT',
                };

                const url = process.env.URL_CDC;
                await axios
                    .post(`${url}`, data, config)
                    .then((res) => {
                        const gigya = gigyaContext.gigyaAccount;
                        const dataUser = {
                            uid: gigya?.UID,
                            signaturetimestamp: gigya?.signatureTimestamp,
                            uidsignature: gigya?.UIDSignature,
                            cellPhone: gigya?.data?.mobile,
                        };
                        const url = process.env.URL_CDC_IDP;
                        const config = {
                            headers: {
                                apikey: CDC_APIKEY_IDP,
                                authorization: `Bearer ${res.data.data.id_token}`,
                            },
                        };

                        axios.post(`${url}`, dataUser, config).then((res) => {
                            const {
                                data: { data },
                            } = res;
                            if (data) {
                                setToken({
                                    ...token,
                                    data,
                                });
                            }
                            cookies.set('uid-r', gigya?.UID, {
                                path: '/',
                                expires: new Date(
                                    new Date(Date.now() + 60 * 10000)
                                ),
                            });
                            cookies.remove('token');
                            cookies.set('token', res.data.data?.userJwt, {
                                path: '/',
                                expires: new Date(
                                    new Date(Date.now() + 60 * 10000)
                                ),
                            });
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getUnloggedToken = async () => {
        const data = await GetUnlogedToken();
        cookies.remove('uid-r');
        cookies.remove('token');
        cookies.set('token', data, {
            path: '/',
            expires: new Date(new Date(Date.now() + 60 * 10000)),
        });
        return true;
    };

    useEffect(() => {
        if (gigyaContext.gigyaAccount?.UID) {
            cookies.remove('token');
            getToken();
        }
    }, [gigyaContext.gigyaAccount?.UID]);

    useEffect(() => {
        const loginUser = cookies.get('uid-r');
        if (!loginUser) {
            cookies.remove('token');
            cookies.remove('uid-r');
            cookies.remove('CURRENT_BUSINESS');
            getUnloggedToken();
        }
    }, []);

    const hasCheckPermissionPage: boolean = useMemo(() => {
        try {
            if (checkPermissionPage && business?.serviceId) {
                return business?.serviceId.find(
                    (item) => item === checkPermissionPage
                );
            }
            if (!gigyaContext?.gigyaAccount || !business) {
                return false;
            }
        } catch (error) {}
        return true;
    }, [business, checkPermissionPage]);

    const doSetSize = (_size: number) => {
        localStorage.setItem('font-size', `${_size}`);
        setSize(_size);
    };

    const toLocalStoragepageActive = () => {
        if (localStorage?.getItem('Redirection')) {
            const storage: any = localStorage?.getItem('Redirection');
            const data = JSON.parse(storage);
            return data.titleButton === 'PORTAL SERVICIOS'
                ? false
                : localStorage?.setItem(
                      'Redirection',
                      JSON.stringify({
                          titleButton: 'PORTAL SERVICIOS',
                          path: 'portal-servicios',
                      })
                  );
        } else {
            return localStorage.setItem(
                'Redirection',
                JSON.stringify({
                    titleButton: 'PORTAL SERVICIOS',
                    path: 'portal-servicios',
                })
            );
        }
    };
    const context = {
        fontSize: { get: size, set: doSetSize },
        superFooter: { get: superFooter, set: setSuperFooter },
        selectedTab: { get: selectedTab, set: setSelectedTab },
        selectedService: { get: selectedService, set: setSelectedService },
        checkPermissionPage: {
            get: checkPermissionPage,
            has: hasCheckPermissionPage,
            set: setCheckPermissionPage,
        },
        business: { get: business, set: setBusiness },
        userVerificationData: {
            get: userVerificationData,
            set: setUserVerificationData,
        },

        gigyaContext: { ...gigyaContext },
        userInfoContext: { ...token },
    };

    let timerScroll: any;

    const onScrollAction = () => {
        window?.clearTimeout(timerScroll);
        timerScroll = setTimeout(() => {
            if (window?.pageYOffset < 70) {
                resetDirection();
            }
        }, 66);
    };

    const [selectedOption, setSelectedOption] = useState<number | null>(null);
    const [openModal, setOpenModal] = useState(false);

    const closeSubmenu = () => {
        setSelectedOption(null);
    };

    useEffect(() => {
        const paths =
            window?.location?.pathname?.charAt(
                window?.location?.pathname?.length - 1
            ) === '/'
                ? window?.location?.pathname?.slice(0, -1).split('/')
                : window?.location?.pathname?.split('/');

        if (paths && paths[paths.length - 1] === TabsEnum.BUSINESS) {
            setIsHome(true);
        } else if (paths && paths[paths.length - 1] === TabsEnum.PEOPLE) {
            setIsHome(true);
        } else {
            setIsHome(false);
        }
    }, []);

    const showSideNav = !(
        window?.location?.pathname?.includes('/certificados') ||
        window?.location?.pathname?.includes('/pagos') ||
        hideSide
    );

    useEffect(() => {
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
    }, []);

    useEffect(() => {
        const { gigyaAccount, isLoadingGigya } = gigyaContext;
        if (!isLoadingGigya && !isPrivate) {
            setTimeout(() => {
                setIsSessionNeeded(false);
                setLoader(false);
            }, 1000);
        } else if (isPrivate && !isLoadingGigya) {
            setTimeout(() => {
                if (gigyaAccount) {
                    setIsSessionNeeded(false);
                    setLoader(false);
                } else {
                    setLoader(false);
                    setIsSessionNeeded(true);
                }
            }, 2000);
        }
    }, [gigyaContext?.gigyaAccount, gigyaContext?.isLoadingGigya]);

    const getBussinesData = () => {
        if (cookies.get('CURRENT_BUSINESS')) {
            const dat = cookies.get('CURRENT_BUSINESS').toString();
            const decryptionObj = CryptoJS.AES.decrypt(dat, 'comfama');
            const decryptedData = JSON.parse(
                decryptionObj.toString(CryptoJS.enc.Utf8)
            );
            business?.set(decryptedData);
            cookies.set(
                'CURRENT_BUSINESS',
                CryptoJS.AES.encrypt(
                    JSON.stringify(decryptedData),
                    'comfama'
                ).toString(),
                {
                    path: '/',
                    expires: new Date(new Date(Date.now() + 60 * 10000)),
                }
            );
        }
    };

    useEffect(() => {
        getBussinesData();
    }, []);

    return (
        <GlobalContext.Provider value={context}>
            <Script
                src={`https://cdns.gigya.com/js/gigya.js?apikey=${GIGYA_API_KEY}&httpStatusCodes=true`}
            />
            <Header
                hideOnMobile={true}
                closeSubmenu={closeSubmenu}
                openModal={openModal}
                setOpenModal={setOpenModal}
                isPrivate={isPrivate}
                serviceId={serviceId}
            />
            <Onbording />
            {sideMenu && <>{sideMenu}</>}
            <Menu
                isDark={isDark}
                actionTheme={changeDarkMode}
                isSearcherActive={isSearcherActive}
                setSearcherActive={setIsSearcherActive}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                close={closeSubmenu}
                isHome={isHome}
                isPrivate={isPrivate}
                serviceId={serviceId}
            />
            <div>
                <main
                    className={`o-main-container ${
                        showSideNav ? '' : 'o-main-container__no-padding'
                    } ${
                        sideMenu
                            ? isMain
                                ? 'o-main-container__big-side'
                                : 'o-main-container__short-side'
                            : ''
                    }`}
                >
                    {hasLoader && loader ? (
                        <div className="o-main__loading">
                            <Loader size="__big" />
                        </div>
                    ) : isSessionNeeded ? (
                        <LoginRequest />
                    ) : (
                        <>{children}</>
                    )}
                </main>
                <ChatButton
                    iconOpen={
                        data.allContentfulPortalServiciosChat.nodes[0].icono
                            .file.url
                    }
                    iconClose={
                        data.allContentfulPortalServiciosChat.nodes[0]
                            .iconoCerrar.file.url
                    }
                    data={
                        data.allContentfulPortalServiciosChat.nodes[0]
                            .botonesInternos
                    }
                />
                <AccesibiltyButton
                    isDark={isDark}
                    actionTheme={changeDarkMode}
                />
                <Footer
                    isSuperFooter={false}
                    bigSide={sideMenu ? isMain : false}
                />
            </div>
        </GlobalContext.Provider>
    );
};

export default Layout;
